import { type ReactNode } from 'react';
import { Botao } from './ui';

/**
 * `CardOnboarding` (DESIGN-FOUNDATION §6.8) — primeira Home, uma vez, dispensável.
 * Nível 2, `--superficie`, abaixo do CTA e acima da régua. **Não é modal** e não
 * escurece a tela: explicação nunca empurra a ação principal para fora do
 * primeiro quadro. Dispensa com botão terciário. "Já viu" mora em `localStorage`.
 */
export function CardOnboarding({ aoDispensar }: { aoDispensar: () => void }): ReactNode {
  return (
    <div className="rounded-2 bg-superficie p-5">
      <p className="tipo-corpo text-tinta">
        <span className="tipo-corpo-forte text-tinta-forte">Este é o seu código.</span> Quando
        alguém fizer um serviço aqui e disser que veio por você, vocês dois ganham um brinde. Quanto
        mais gente, melhores os brindes.
      </p>
      <div className="mt-3">
        <Botao variante="terciario" onClick={aoDispensar}>
          Entendi
        </Botao>
      </div>
    </div>
  );
}
